<template>
  <div class="withinOrdersPage">
    <div class="container">
      <div class="searchView">
        <div class="cellLs">
          <div class="cellWrap">
            <span class="label">订单时间：</span>
            <!-- <select v-model="searchParam.dateType" class="dateSelect" @change="dateChange">
              <option v-for="item in options.dateList" :key="item.id || 0" :value="item.id">
                {{ item.label }}
              </option>
            </select> -->
            <el-date-picker
              style="width: 270px"
              type="daterange"
              v-model="searchParam.dateType"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="dateChange"
            >
            </el-date-picker>
          </div>
          <div class="cellWrap">
            <span class="label">金额范围：</span>
            <div class="rangeWrap">
              <input class="input" type="text" v-model="searchParam.appointPriceBegin" />
              <span class="bar">-</span>
              <input class="input" type="text" v-model="searchParam.appointPriceEnd" />
              <div class="popover">
                <p @click="clearPrice()">清空</p>
                <button @click="doSearch()">确定</button>
              </div>
            </div>
          </div>
          <div class="cellWrap">
            <!--<span>老师编号：</span>-->
            <select v-model="searchParam.numberType" style="margin-right: 10px">
              <option value="4">老师编号</option>
              <option value="2">订单编号</option>
            </select>
            <input
              class="input right"
              type="text"
              v-model="searchParam.numberStr"
              :placeholder="searchParam.numberType === '4' ? '输入老师编号' : '输入订单编号'"
            />
          </div>
          <div class="cellWrap">
            <span class="label">客服id：</span>
            <w-select v-model="searchParam.waiterId" placeholder="输入客服id" :options="waiterOptions"></w-select>
            <!-- <input class="right" type="text" v-model="searchParam.waiterId" placeholder="输入客服id" /> -->
          </div>
        </div>
        <div class="searchHandle">
          <button class="search" @click="doSearch()">搜索</button>
          <button class="resat" @click="handleClear">重置</button>
        </div>
      </div>
      <div class="searchFilter">
        <ul>
          <li
            v-for="(item, idx) in options.customerOrderType"
            :key="idx"
            :class="{ on: item.id == searchParam.customerOrderType }"
            @click="changeStatus(item.id)"
          >
            {{ item.label }}
          </li>
        </ul>
        <!-- <div class="help" @click="openHelp">下单帮助</div> -->
      </div>
      <div class="tableTools">
        <div>
          <button class="create" @click="createOrder">新建订单</button>
          <button @click="batchPay">批量支付</button>
        </div>
        <div>
          <button :disabled="page.pageNo <= 1" @click="prevPage">上一页</button>
          <button :disabled="page.pageNo >= page.totalPage" @click="nextPage">下一页</button>
        </div>
      </div>
      <div v-if="fillData.datas && fillData.datas.length" class="mainTable">
        <table>
          <thead>
            <tr>
              <td class="checkbox">
                <input type="checkbox" value="1" v-model="allSelected" />
              </td>
              <td class="name">稿件名称</td>
              <td class="dubber">选定老师</td>
              <td class="priced">定价</td>
              <td class="realPay">实际付款</td>
              <td class="status">订单状态</td>
              <td class="waiter">客服</td>
              <td class="duration">时长</td>
              <td class="handle">操作</td>
            </tr>
          </thead>
          <tbody>
            <template v-for="item in fillData.datas || []">
              <tr class="interval" :key="'interval_' + item.id"></tr>
              <!-- <tr :key="'hd_' + item.id" class="orderTh">
                <td class="checkbox">
                  <input type="checkbox" :value="item.id" v-model="selected" />
                </td>
                <td colspan="8">
                  <div class="timeWrap">
                    <span class="dealtime">{{ item.createTime }}</span>
                    <span class="invoiced" v-if="item.invoiceId"></span>
                  </div>
                </td>
              </tr> -->
              <tr :key="item.id" class="orderTd">
                <td class="checkbox">
                  <input type="checkbox" value="1" v-model="allSelected" />
                </td>
                <td class="name">
                  <span :class="item.contributionId ? 'down-load' : ''" @click="downContribution(item)"
                    >{{ item.contributionName }}
                  </span>
                </td>
                <td class="dubber">{{ item.dubboNum }}</td>
                <td class="priced">{{ item.appointPrice }}</td>
                <td class="realPay">{{ item.realityPrice }}</td>
                <td class="status">
                  <i class="demand on" v-jq-tips="'已需求'"></i>
                  <i
                    class="demo"
                    :class="{ on: item.auditionIds }"
                    v-jq-tips="item.auditionIds ? '已有老师试音，查看试音详情请点击右侧‘查看试音’' : '尚无老师试音'"
                  ></i>
                  <i
                    class="pay"
                    :class="{ on: item.payId }"
                    v-jq-tips="item.payId ? '已经支付订单费用' : '订单尚未支付'"
                  ></i>
                  <i
                    class="finished"
                    :class="{ on: item.productId || item.voiceLength }"
                    v-jq-tips="item.productId || item.voiceLength ? '已经录制成品' : '尚未录制成品'"
                  ></i>
                  <i class="canceled" v-if="item.orderStatus == 10" v-jq-tips="'已取消'"></i>
                </td>
                <td class="waiter">{{ item.waiterName }}</td>
                <td class="duration">{{ item.voiceLength }}</td>
                <td class="handle">
                  <div>
                    <div>
                      <button class="payBtn" v-if="canPay(item)" @click="singlePay(item)">立即支付</button>
                    </div>
                    <div>
                      <button v-if="item.auditionIds" @click="lookVoiceList(item)">查看试音</button>
                    </div>
                    <router-link
                      :to="{ name: 'Discuss', query: { id: item.orderNum } }"
                      class="discuss"
                      v-if="item.payId"
                      >{{ item.dubbingGrade ? '查看评论' : '评价订单' }}</router-link
                    >
                  </div>
                  <!-- <a v-if="canDownContribution(item)" @click="downContribution(item)">下载稿件</a> -->
                </td>
              </tr>
            </template>
          </tbody>
        </table>

        <div class="summation" v-if="summation || summation === 0">
          <p>
            合计实付金额： <span>{{ summation }}</span
            >元
          </p>
        </div>
        <div class="table_footer_tools">
          <button class="btn_g ghost" @click="getStatistics()">查看合计</button>
          <button class="btn_g ghost" @click="getExcel()">导出本页表格</button>
          <button class="btn_g ghost" @click="getAllExcel">导出所有表格</button>
        </div>
        <div class="page_wrap">
          <app-page-ajax ref="pager" :page-data="page" @page-change="pageChange"></app-page-ajax>
        </div>
      </div>

      <div v-else class="g_empty">
        <p class="info">没有检测到相关的订单~</p>
      </div>
    </div>
    <sd-modal v-show="viewVoice">
      <div class="demo_voice_dialog">
        <div class="title">
          您的试音
          <i class="close" @click="viewVoice = false"></i>
        </div>
        <ul>
          <li v-for="(vo, index) in voiceLists" :key="index" :sound-id="vo.id">
            <span class="number">{{ index + 1 }}</span>
            <span class="dubber">{{ vo.auditionDubboNum + '号' }}</span>
            <span class="voice" :title="vo.auditionName">{{ vo.auditionName }}</span>
            <i class="play sound-play"></i>
          </li>
        </ul>
      </div>
    </sd-modal>

    <div class="viki_modal">
      <sd-modal v-show="forHelp">
        <div class="viki">
          <div class="bg">
            <transition name="fade">
              <div class="first" v-if="orderViki.first">
                <div
                  class="btn"
                  @click="
                    orderViki.first = false;
                    orderViki.second = true;
                  "
                ></div>
              </div>
            </transition>
            <transition name="fade">
              <div class="second" v-if="orderViki.second">
                <div
                  class="btn"
                  @click="
                    orderViki.second = false;
                    orderViki.third = true;
                  "
                ></div>
              </div>
            </transition>
            <transition name="fade">
              <div class="third" v-if="orderViki.third">
                <div
                  class="btn"
                  @click="
                    orderViki.third = false;
                    forHelp = false;
                  "
                ></div>
              </div>
            </transition>
          </div>
        </div>
      </sd-modal>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';
import { util } from '../service/util';
import { service } from '../service/service';
import AppPageAjax from '../components/sdPager';
import sdModal from '../components/sdModal.vue';
import $axios from '../service/axios';
import WSelect from '../components/w-select.vue';
let API = util.api([
  'LOGINBYCUSTOMERID',
  'FINDMYORDER',
  'FINDMYAUDITION',
  'GETCONTRIBUTIONBYID',
  'GETSTATISTICSBYCUSTOMERSEARCH',
  'DOWNLOADORDERINFO',
  'GETALLINNERUSER'
]);
export default {
  components: {
    AppPageAjax,
    sdModal,
    WSelect
  },
  data() {
    return {
      customerId: '',
      customerInfo: {},
      fillData: {},
      searchParam: {
        numberType: '4',
        customerOrderType: '',
        waiterId: '',
        appointPriceBegin: '',
        appointPriceEnd: '',
        numberStr: '',
        beginDate: '',
        endDate: '',
        dateType: []
      },
      selected: [],
      summation: null,
      preventErr: {
        text: '',
        toLink: '',
        toText: ''
      },

      allSelected: '',

      viewVoice: false,
      // 试音列表
      voiceLists: [],

      forHelp: false,
      orderViki: {
        first: false,
        second: false,
        third: false
      },
      waiterOptions: [],

      options: {
        orderStatus: {
          1: '需求中',
          2: '试音中',
          3: '待支付',
          4: '录制中',
          5: '已成品',
          6: '已成品',
          8: '已成品',
          10: '已取消'
        },
        customerOrderType: [
          { id: '', label: '全部订单' },
          { id: '1', label: '需求中' },
          { id: '2', label: '试音中' },
          { id: '3', label: '待支付' },
          { id: '4', label: '录制中' },
          { id: '5', label: '已成品' }
          // { id:'10',label:'已取消'}
        ],
        dateList: [
          { id: '', label: '全部', beginDate: '', endDate: '' },
          {
            id: '1',
            label: '近三个月订单',
            beginDate: moment().add(-3, 'M').format('YYYY-MM-DD 00:00:00'),
            endDate: moment().format('YYYY-MM-DD 23:59:59')
          },
          {
            id: '2',
            label: '近六个月订单',
            beginDate: moment().add(-6, 'M').format('YYYY-MM-DD 00:00:00'),
            endDate: moment().format('YYYY-MM-DD 23:59:59')
          },
          {
            id: '3',
            label: '近两年订单',
            beginDate: moment().add(-2, 'y').format('YYYY-MM-DD 00:00:00'),
            endDate: moment().format('YYYY-MM-DD 23:59:59')
          },
          {
            id: '3',
            label: '一年前的订单',
            beginDate: '',
            endDate: moment().add(-1, 'Y').format('YYYY-MM-DD 00:00:00')
          }
        ]
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '近三个月订单',
            onClick(picker) {
              const end = moment().format('YYYY-MM-DD 23:59:59');
              const start = moment().add(-3, 'M').format('YYYY-MM-DD 00:00:00');
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '近六个月订单',
            onClick(picker) {
              const end = moment().format('YYYY-MM-DD 23:59:59');
              const start = moment().add(-6, 'M').format('YYYY-MM-DD 00:00:00');
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '一年前的订单',
            onClick(picker) {
              const end = moment().add(-1, 'Y').format('YYYY-MM-DD 00:00:00');
              const start = moment().add(-5, 'Y').format('YYYY-MM-DD 00:00:00');
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      _options: (state) => state.common.options
    }),
    page() {
      let { pageNo = 1, pageSize = 20, totalPage = 1, totalRecord = 0 } = this.fillData;
      return { pageNo, pageSize, totalPage, totalRecord };
    }
  },
  watch: {
    selected() {
      let isAll = this.selected.length === (this.fillData.datas || []).length;
      this.allSelected = isAll ? '1' : '';
    },
    allSelected(val) {
      if (val) {
        this.selected = (this.fillData.datas || []).map((d) => d.id);
      } else {
        this.selected = [];
      }
    }
  },
  created() {
    let { customerId, customerOrderType, waiterId } = this.$route.query;
    customerId = decodeURIComponent(customerId);
    this.customerId = customerId;
    this.searchParam.customerOrderType = customerOrderType || '';
    this.searchParam.waiterId = waiterId || '';
  },
  mounted() {
    if (this.customerId) {
      $axios
        .post(API['LOGINBYCUSTOMERID'], {
          customerIdData: this.customerId
        })
        .then(({ data }) => {
          this.customerInfo = data || {};
          this.init();
        });
    }
  },
  methods: {
    async init() {
      $axios.post(API['GETALLINNERUSER']).then(({ data }) => {
        if (data) {
          this.waiterOptions = data.map((d) => ({ value: d.baseId, label: d.userPetname + '/' + d.userName }));
        }
      });
      this.doSearch();
    },
    getSearchParam() {
      let param = { ...this.searchParam };
      delete param.dateType;
      Object.keys(param).forEach((k) => {
        if (typeof param[k] === 'string') param[k] = param[k].replace(/(^\s*)|(\s*$)/g, '');
        if (param[k] === undefined || param[k] === '') delete param[k];
      });
      return param;
    },
    doSearch(pageNo) {
      $axios
        .post(API['FINDMYORDER'], {
          searchOrder: this.getSearchParam(),
          pageNo: pageNo || this.page.pageNo,
          pageSize: 20
        })
        .then(({ data }) => {
          if (data) {
            this.fillData = data || {};
          }
        });
    },

    getUserInfo() {
      this.$store.dispatch('auth/AUTH_GETCUSTOMERINFO');
    },
    pageChange(pageNo) {
      this.fillData.pageNo = pageNo;
      this.doSearch(pageNo);
    },
    handleClear() {
      this.searchParam = {
        numberType: '4',
        customerOrderType: '',
        waiterId: '',
        appointPriceBegin: '',
        appointPriceEnd: '',
        numberStr: '',
        beginDate: '',
        endDate: '',
        dateType: ''
      };
      this.doSearch();
    },
    createOrder() {
      service.creatOrder(this.doSearch);
    },
    prevPage() {
      this.$refs.pager.prePage();
    },
    nextPage() {
      this.$refs.pager.nextPage();
    },
    batchPay() {
      // 1. 已定价 2. 未支付 3. 未终止
      let orders = (this.fillData.datas || []).filter((d) => this.selected.includes(d.id));
      let orderError = orders.find((d) => !this.canPay(d));
      if (orderError) {
        util.confirm.error('请选择已定价而未支付的订单！');
        return;
      }
      if (!orders.length) {
        util.confirm.error('无可支付的订单！');
        return;
      }
      this.$store.commit('PAYORDERS', orders);
      this.$router.push({
        name: 'PayView'
      });
    },

    dateChange(values) {
      this.searchParam.beginDate = values[0];
      this.searchParam.endDate = values[1];
    },
    /**
     * 单个支付
     */
    singlePay(item) {
      let orders = [item];
      this.$store.commit('PAYORDERS', orders);
      this.$router.push({
        name: 'PayView'
      });
    },
    productPlay(row) {
      let param = {
        id: 'audition_' + row.id,
        path: row.auditionServerPath,
        title: row.auditionName
      };
      this.playByPath(param);
    },
    // 查看试音
    lookVoiceList({ auditionIds }) {
      let ids = auditionIds.split(',');
      $axios.post(API['FINDMYAUDITION'], { ids }).then(({ data }) => {
        if (data) {
          this.viewVoice = true;
          util.addSoundData(data);
          this.voiceLists = data;
        }
      });
    },
    // 下载稿件
    downContribution(r) {
      if (!r.contributionId) {
        return;
      }
      if (r.realPath) {
        this.downFileHandle(r.realPath);
        return;
      }
      $axios.post(API['GETCONTRIBUTIONBYID'], { id: r.contributionId }).then(({ data }) => {
        if (data) {
          r.realPath = 'https://transaction.oss-cn-shanghai.aliyuncs.com/' + data.contributionServerPath;
          this.downFileHandle(r.realPath);
        }
      });
    },
    downFileHandle(path) {
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = path;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // 可支付
    canPay(item) {
      return item.orderStatus >= 3 && item.orderStatus != 10 && !item.payId;
    },

    changeStatus(id) {
      // 清空页数
      this.$set(this.searchParam, 'customerOrderType', id);
      this.doSearch(1);
    },

    // 下单帮助
    openHelp() {
      this.forHelp = true;
      this.orderViki.first = true;
    },

    // 查看合计
    getStatistics() {
      let param = {
        searchOrder: this.getSearchParam()
      };
      $axios.post(API['GETSTATISTICSBYCUSTOMERSEARCH'], param).then(({ data }) => {
        if (!data) {
          this.summation = null;
        } else {
          if (param.searchOrder.customerOrderType == 3) {
            // 22.04.14 this.searchParam.customerOrderType === 3 表示选中的标签页是待支付
            // 待支付的合计显示字段变更
            this.summation = data.appointPrice || 0;
            return;
          }
          this.summation = data.realityPrice || 0;
        }
      });
    },
    // 导出本页表格
    getExcel() {
      var data = util.copy(this.fillData.datas || []),
        src = [],
        title = ['稿件名称', '紧急', '选定老师', '定价', '实际付款', '订单状态', '创建时间'];

      if (!data.length) {
        util.confirm.error('无订单数据！');
        return;
      }

      data.forEach((d, i) => {
        src.push([
          d.contributionName,
          this._options.pressingStatus[d.pressingStatus],
          d.dubboNum,
          d.appointPrice,
          d.realityPrice,
          this.options.orderStatus[d.orderStatus],
          moment(d.createTime).format('MM-DD HH:mm')
        ]);
      });
      util.toCSV(src, title, '订单信息' + moment().format('MM-DD HH:mm') + '.csv');
    },
    // 导出所有表格
    getAllExcel() {
      let param = this.getSearchParam();
      let str = '';
      for (let i in param) {
        if (param[i]) {
          str += `${i}=${param[i]}&`;
        }
      }
      str = str.substring(0, str.length - 1);
      window.open(`${API.DOWNLOADORDERINFO}?${str}`);
    }
  },

  async asyncData(ctx) {
    const { store, params, error, query } = ctx;
    let { customerId, customerOrderType, waiterId } = query;
    customerId = decodeURIComponent(customerId);
    try {
      return {
        customerId,
        customerOrderType,
        waiterId
      };
    } catch (err) {
      error({ statusCode: 404, message: err });
    }
  }
};
</script>
<style lang="scss">
@import '../assets/sass/withinOrders.scss';
</style>



// WEBPACK FOOTER //
// withinOrders.vue?3f77f144